import { Modal, Text, Button, Flex } from "@mantine/core";

/**
 * Modal component that displays a success message after a payment is processed.
 * @param {boolean} opened - Determines whether the modal is visible.
 * @param {function} onClose - Callback function to close the modal.
 * @param {ReactElement} icon - The icon to display in the success message.
 * @param {string} message - The success message to display.
 * @param {string} title - The title of the success message.
 *  @param {string} buttonText - The text to display on the close button.
 * @returns {ReactElement} The payment success modal component.
 */

export const SuccessModal = ({
  opened,
  onClose,
  icon,
  title,
  message,
  buttonText,
}) => {
  return (
    <Modal
      centered
      size="md"
      radius="lg"
      zIndex={1000}
      opened={opened}
      onClose={onClose}
      transition="fade"
      withCloseButton={false}
      transitionProps={{ duration: 200 }}
      styles={{ header: { display: "none" } }}
      overlayProps={{ opacity: 0.55, blur: 3 }}
    >
      <Flex direction="column" align="center" justify="center" gap="sm" mt="md">
        {icon}
        <Text size="18px" fw={600} ff="Inter" c={"#262626"}>
          {title}
        </Text>
        <Text size="14px" fw={400} ff="Inter" ta={"center"} c={"#737373"}>
          {message}
        </Text>
      </Flex>
      <Flex justify="center" gap="sm" mt="md">
        <Button color="yellow" onClick={onClose} radius="md" c="#000" w={150}>
          {buttonText}
        </Button>
      </Flex>
    </Modal>
  );
};
